import type { GalleryMediaT } from '../../../../../type/galleryMediaT';

import { resolveImageUrl } from '@vs-shop/engine/image/resolveImageUrl';

import { GalleryVideoMedia } from '../../../../client/page/product/gallery/GalleryVideoMedia';
import { ProductGalleryImage, ProductGalleryVariant } from '@vs-shop/commerce-ui/productGallery';

import { getYoutubeVideoEmbedFromPath } from '../../../../../effect/utils/youtube/youtube';
import { ImageFilter } from '@vs-shop/engine/image/ImageFilter';

type Props = {
  media: GalleryMediaT;
  alt: string;
  isActive: boolean;
  preload?: boolean;
};

/**
 * Which of rcprofi's two media renderings a gallery slot gets, and the URL each
 * needs.
 *
 * Both halves are this tenant's: the Liip filter that turns a stored path into a
 * renderable main-view crop, and the YouTube embed URL. The shared parts take
 * final URLs only.
 */
export function GalleryMainMedia({ media, alt, isActive, preload }: Props) {
  if (media.mediaType === 'image') {
    const path = media.pathAbstract
      ? resolveImageUrl(media.pathAbstract, ImageFilter.product_gallery_preview_main)
      : '';

    return (
      <ProductGalleryImage
        variant={ProductGalleryVariant.INLINE}
        src={path}
        alt={alt}
        width={924}
        height={693}
        preload={preload === true}
      />
    );
  }

  return (
    <GalleryVideoMedia
      src={getYoutubeVideoEmbedFromPath(media.path)}
      title={alt}
      isActive={isActive}
    />
  );
}
